<template>
  <path
    d="M6 13.0002H18C18.55 13.0002 19 12.5502 19 12.0002C19 11.4502 18.55 11.0002 18 11.0002H6C5.45 11.0002 5 11.4502 5 12.0002C5 12.5502 5.45 13.0002 6 13.0002ZM4 17.0002H16C16.55 17.0002 17 16.5502 17 16.0002C17 15.4502 16.55 15.0002 16 15.0002H4C3.45 15.0002 3 15.4502 3 16.0002C3 16.5502 3.45 17.0002 4 17.0002ZM7 8.00024C7 8.55024 7.45 9.00024 8 9.00024H20C20.55 9.00024 21 8.55024 21 8.00024C21 7.45024 20.55 7.00024 20 7.00024H8C7.45 7.00024 7 7.45024 7 8.00024Z"
  />
</template>
